import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "floating-classroom-ai" }
const _hoisted_2 = { class: "idea-launch" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["data-batch-anchor"]
const _hoisted_5 = { class: "idea-batch-head" }
const _hoisted_6 = { class: "idea-batch-title" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "idea-items" }
const _hoisted_9 = { class: "idea-row" }
const _hoisted_10 = { class: "idea-index" }
const _hoisted_11 = { class: "idea-actions" }
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "idea-draw-result"
}
const _hoisted_15 = {
  key: 1,
  class: "idea-draw-result"
}
const _hoisted_16 = { class: "idea-draw-visual" }
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "idea-draw-zoom-hint"
}
const _hoisted_20 = {
  key: 0,
  class: "idea-draw-shimmer",
  "aria-hidden": "true"
}
const _hoisted_21 = { class: "idea-draw-footer" }
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = {
  key: 2,
  class: "idea-draw-error"
}
const _hoisted_24 = { class: "idea-batch-footer" }
const _hoisted_25 = { class: "idea-batch-actions" }
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = ["data-loading-anchor"]
const _hoisted_28 = {
  key: 1,
  class: "idea-chat"
}
const _hoisted_29 = {
  key: 2,
  class: "idea-loading",
  "data-loading-anchor": "inspire"
}
const _hoisted_30 = { class: "modal-panel draw-preview-panel" }
const _hoisted_31 = { class: "modal-head" }
const _hoisted_32 = ["src"]

import { useFloatingClassroomAi } from '@/components/timetable/classroomAi/useFloatingClassroomAi';


export default /*@__PURE__*/_defineComponent({
  __name: 'FloatingClassroomAi',
  setup(__props) {

const {
  panelOpen,
  visibleBatches,
  inspireLoading,
  loadingBatchState,
  bindIdeaListRef,
  drawPreviewVisible,
  drawPreviewUrl,
  togglePanel,
  onInspire,
  onRefreshBatch,
  onDeepen,
  onDraw,
  onRedraw,
  getDrawState,
  isDrawBusy,
  jumpToBatch,
  openDrawPreview,
  closeDrawPreview,
} = useFloatingClassroomAi();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", {
      class: _normalizeClass(["ai-panel", { 'is-open': _unref(panelOpen) }]),
      "aria-label": "课堂 AI 助手"
    }, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ai-panel-head" }, [
        _createElementVNode("div", { class: "status-pill" }, "AI 已连接"),
        _createElementVNode("strong", null, "课堂 AI 助手")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "primary-trigger",
          disabled: _unref(inspireLoading),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onInspire) && _unref(onInspire)(...args)))
        }, " 灵光一闪 ", 8, _hoisted_3)
      ]),
      _createElementVNode("div", {
        ref: _unref(bindIdeaListRef),
        class: "idea-list"
      }, [
        (_unref(visibleBatches).length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(visibleBatches), (batch, batchIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${batch.label}-${batch.time}-${batchIndex}`
              }, [
                _createElementVNode("div", {
                  class: "idea-batch",
                  "data-batch-anchor": batchIndex
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(batch.label) + _toDisplayString(batch.time ? ` (${batch.time})` : ''), 1),
                    (batch.sourceType === 'deepen' && batch.sourceBatchIndex != null && batch.sourceBatchIndex >= 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "idea-back",
                          onClick: ($event: any) => (_unref(jumpToBatch)(batch.sourceBatchIndex))
                        }, " 返回上层 ", 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(batch.items, (item, itemIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${batchIndex}-${itemIndex}`,
                        class: "idea-chat"
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(itemIndex + 1) + ".", 1),
                          _createElementVNode("b", null, _toDisplayString(item.question), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "idea-action idea-action--draw",
                            disabled: _unref(isDrawBusy)(batchIndex, itemIndex),
                            onClick: ($event: any) => (_unref(onDraw)(batchIndex, itemIndex, item))
                          }, " 画图 ", 8, _hoisted_12),
                          _createElementVNode("button", {
                            type: "button",
                            class: "idea-action",
                            onClick: ($event: any) => (_unref(onDeepen)(batchIndex, item))
                          }, " 继续深挖 ", 8, _hoisted_13)
                        ]),
                        (_unref(getDrawState)(batchIndex, itemIndex)?.loading && !_unref(getDrawState)(batchIndex, itemIndex)?.url)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[4] || (_cache[4] = [
                              _createElementVNode("div", { class: "idea-draw-loading" }, [
                                _createElementVNode("span", {
                                  class: "idea-draw-spinner",
                                  "aria-hidden": "true"
                                }),
                                _createElementVNode("span", null, "示意图生成中...")
                              ], -1)
                            ])))
                          : (_unref(getDrawState)(batchIndex, itemIndex)?.url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["idea-draw-thumb", { 'is-refreshing': _unref(getDrawState)(batchIndex, itemIndex)?.refreshing }]),
                                    disabled: _unref(getDrawState)(batchIndex, itemIndex)?.refreshing,
                                    "aria-label": "点击放大示意图",
                                    onClick: ($event: any) => (_unref(openDrawPreview)(_unref(getDrawState)(batchIndex, itemIndex)?.url || ''))
                                  }, [
                                    _createElementVNode("img", {
                                      src: _unref(getDrawState)(batchIndex, itemIndex)?.url,
                                      alt: "示意图预览"
                                    }, null, 8, _hoisted_18),
                                    (!_unref(getDrawState)(batchIndex, itemIndex)?.refreshing)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "点击放大"))
                                      : _createCommentVNode("", true)
                                  ], 10, _hoisted_17),
                                  (_unref(getDrawState)(batchIndex, itemIndex)?.refreshing)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[5] || (_cache[5] = [
                                        _createElementVNode("span", { class: "idea-draw-shimmer-text" }, "重新生成中", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "idea-draw-redraw",
                                    disabled: _unref(getDrawState)(batchIndex, itemIndex)?.refreshing,
                                    onClick: ($event: any) => (_unref(onRedraw)(batchIndex, itemIndex, item))
                                  }, " 重新生成 ", 8, _hoisted_22)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                        (_unref(getDrawState)(batchIndex, itemIndex)?.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(getDrawState)(batchIndex, itemIndex)?.error), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "idea-action",
                        disabled: _unref(loadingBatchState)?.batchIndex === batchIndex,
                        onClick: ($event: any) => (_unref(onRefreshBatch)(batchIndex))
                      }, " 换一批 ", 8, _hoisted_26)
                    ])
                  ])
                ], 8, _hoisted_4),
                (_unref(loadingBatchState)?.batchIndex === batchIndex)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "idea-loading",
                      "data-loading-anchor": batchIndex
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("div", { class: "idea-loading-top" }, [
                        _createElementVNode("div", {
                          class: "idea-loader",
                          "aria-hidden": "true"
                        }, [
                          _createElementVNode("span"),
                          _createElementVNode("span"),
                          _createElementVNode("span")
                        ]),
                        _createElementVNode("b", null, "思考中...")
                      ], -1)
                    ]), 8, _hoisted_27))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          : (!_unref(inspireLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[7] || (_cache[7] = [
                _createElementVNode("b", null, "点击「灵光一闪」获取本阶段教学灵感。", -1)
              ])))
            : _createCommentVNode("", true),
        (_unref(inspireLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "idea-loading-top" }, [
                _createElementVNode("div", {
                  class: "idea-loader",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("span"),
                  _createElementVNode("span"),
                  _createElementVNode("span")
                ]),
                _createElementVNode("b", null, "思考中...")
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ], 512)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["floating-ai-wrap", { 'is-open': _unref(panelOpen) }])
    }, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["floating-ai", { 'is-open': _unref(panelOpen) }]),
        "aria-label": "打开课堂 AI",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(togglePanel) && _unref(togglePanel)(...args)))
      }, null, 2)
    ], 2),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "floating-ai-label" }, "一键打开课堂 AI 助手", -1)),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createElementVNode("div", {
        class: "classroom-ai-modal draw-preview-modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "示意图大图",
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(closeDrawPreview) && _unref(closeDrawPreview)(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _cache[10] || (_cache[10] = _createElementVNode("strong", null, "示意图预览", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "modal-close",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(closeDrawPreview) && _unref(closeDrawPreview)(...args)))
            }, "关闭")
          ]),
          _createElementVNode("img", {
            src: _unref(drawPreviewUrl),
            class: "draw-preview-image",
            alt: "示意图预览"
          }, null, 8, _hoisted_32)
        ])
      ], 512), [
        [_vShow, _unref(drawPreviewVisible)]
      ])
    ]))
  ]))
}
}

})